(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this.body = this.querySelector('[data-cart-drawer-body]');
        this.upsell = this.querySelector('[data-cart-drawer-upsell]');
        this.footer = this.querySelector('[data-cart-drawer-footer]');
        this.subtotalEl = this.querySelector('[data-cart-drawer-subtotal]');
        this.shippingProgress = this.querySelector('[data-cart-drawer-shipping]');
        this.shippingMessageEl = this.querySelector('[data-cart-drawer-shipping-message]');
        this.shippingFillEl = this.querySelector('[data-cart-drawer-shipping-fill]');
        this.freeShippingThreshold = Number(this.dataset.freeShippingThreshold) || 0;

        document.addEventListener('click', (event) => {
          if (event.target.closest('[data-cart-drawer-open]')) {
            event.preventDefault();
            this.open();
          } else if (event.target.closest('[data-cart-drawer-close]')) {
            this.close();
          }
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.hidden) this.close();
        });

        document.addEventListener('cart:updated', (event) => {
          this.render(event.detail);
          this.open();
        });

        this.body.addEventListener('click', (event) => {
          const removeBtn = event.target.closest('[data-cart-remove]');
          const decreaseBtn = event.target.closest('[data-cart-decrease]');
          const increaseBtn = event.target.closest('[data-cart-increase]');

          if (removeBtn) this.changeLine(removeBtn.dataset.key, 0);
          if (decreaseBtn) this.changeLine(decreaseBtn.dataset.key, Number(decreaseBtn.dataset.quantity) - 1);
          if (increaseBtn) this.changeLine(increaseBtn.dataset.key, Number(increaseBtn.dataset.quantity) + 1);
        });

        if (this.upsell) {
          this.upsell.addEventListener('click', (event) => {
            const addBtn = event.target.closest('[data-cart-upsell-add]');
            if (addBtn) this.addVariant(addBtn.dataset.variantId, addBtn);
          });
        }
      }

      open() {
        this.hidden = false;
        document.body.classList.add('cart-drawer-open');
        this.refresh();
      }

      close() {
        this.hidden = true;
        document.body.classList.remove('cart-drawer-open');
      }

      async refresh() {
        const response = await fetch('/cart.js');
        this.render(await response.json());
      }

      async changeLine(key, quantity) {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
        });
        this.render(await response.json());
      }

      async addVariant(variantId, button) {
        if (button) button.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          await this.refresh();
        } finally {
          if (button) button.disabled = false;
        }
      }

      formatMoney(cents, currency) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency',
            currency,
          }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2);
        }
      }

      resizeImage(url, width) {
        if (!url) return url;
        return url.includes('?') ? `${url}&width=${width}` : `${url}?width=${width}`;
      }

      updateShippingProgress(cart) {
        if (!this.shippingProgress || this.freeShippingThreshold <= 0) return;

        const remaining = this.freeShippingThreshold - cart.total_price;
        const percent = Math.min(100, (cart.total_price / this.freeShippingThreshold) * 100);
        this.shippingFillEl.style.width = `${percent}%`;

        if (remaining <= 0) {
          this.shippingMessageEl.textContent = this.dataset.freeShippingUnlocked;
          this.shippingProgress.classList.add('is-complete');
        } else {
          this.shippingMessageEl.textContent = this.dataset.freeShippingRemainingTemplate.replace(
            '__AMOUNT__',
            this.formatMoney(remaining, cart.currency)
          );
          this.shippingProgress.classList.remove('is-complete');
        }
      }

      updateUpsell(cart) {
        if (!this.upsell) return;

        const cartHandles = new Set(cart.items.map((item) => item.handle));
        const items = this.upsell.querySelectorAll('[data-cart-upsell-handle]');
        let visibleCount = 0;

        items.forEach((item) => {
          const inCart = cartHandles.has(item.dataset.cartUpsellHandle);
          item.hidden = inCart;
          if (!inCart) visibleCount += 1;
        });

        this.upsell.hidden = visibleCount === 0;
      }

      render(cart) {
        document.dispatchEvent(new CustomEvent('cart:count-updated', { detail: cart }));

        if (!cart.items.length) {
          this.body.innerHTML = `
            <div class="cart-drawer__empty">
              <p>${this.dataset.emptyLabel}</p>
              <a href="${this.dataset.continueUrl}" data-cart-drawer-close>${this.dataset.continueLabel}</a>
            </div>
          `;
          this.footer.hidden = true;
          if (this.upsell) this.upsell.hidden = true;
          return;
        }

        this.footer.hidden = false;
        this.subtotalEl.textContent = this.formatMoney(cart.total_price, cart.currency);
        this.updateShippingProgress(cart);
        this.updateUpsell(cart);

        this.body.innerHTML = cart.items
          .map(
            (item) => `
              <div class="cart-drawer__item">
                <a href="${item.url}" class="cart-drawer__item-image">
                  <img src="${this.resizeImage(item.image, 160)}" alt="${item.title}" loading="lazy" width="80" height="80">
                </a>
                <div class="cart-drawer__item-content">
                  <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
                  ${item.variant_title ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : ''}
                  <div class="cart-drawer__item-row">
                    <div class="cart-drawer__item-stepper">
                      <button type="button" data-cart-decrease data-key="${item.key}" data-quantity="${item.quantity}" aria-label="−">−</button>
                      <span>${item.quantity}</span>
                      <button type="button" data-cart-increase data-key="${item.key}" data-quantity="${item.quantity}" aria-label="+">+</button>
                    </div>
                    <span class="cart-drawer__item-price">${this.formatMoney(item.final_line_price, cart.currency)}</span>
                  </div>
                </div>
                <button type="button" class="cart-drawer__item-remove" data-cart-remove data-key="${item.key}" aria-label="${this.dataset.removeLabel}">
                  <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                    <path d="M4 6H16M8 6V4.5C8 4.22386 8.22386 4 8.5 4H11.5C11.7761 4 12 4.22386 12 4.5V6M15 6L14.4 15.4C14.362 16.005 13.86 16.5 13.25 16.5H6.75C6.14 16.5 5.638 16.005 5.6 15.4L5 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            `
          )
          .join('');
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
